// chat.ts
import { toast } from 'react-toastify';
import { IMessage } from '../interface/message';
import { apiClient } from './ky';
//send message

export const sendMessage = async (
  message: IMessage, 
  onChunk: (chunk: string) => void
): Promise<void> => {
  try {
    await apiClient.postStream(
      'api/v1/chat/news/completions', 
      message,
      { 
        onChunk: async (chunk: string) => {
          // Xử lý nhiều chunk có prefix "0:"
          const chunks = chunk.split('0:').filter(Boolean);
          for (const chunk of chunks) {
            // await new Promise((resolve) => setTimeout(resolve, 200));
            const data = JSON.parse(chunk);
            onChunk(data);
          }
        }
      }
    );
  } catch (error) {
    console.log('fffff');
    
    toast.error('Lỗi khi gửi tin nhắn', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    console.error('Error in chat stream:', error);
    throw error;
  }
};
